import { getSearchUrl, getStoreUrl, getSubCategoryUrl } from '../../../../utils/url';
import { POPULAR_SEARCH_TYPES, popularSearches } from '../config';

const TAG_SOURCE = 'hplo_search_tag';

/**
 * This method will create a url route based on the tag
 * @param {object} tag data
 * @param {number} pos - tag position in popular search
 * @return {string} path
 * **/
export const getTagPath = (tag, pos) => {
    switch (tag.type) {
        case POPULAR_SEARCH_TYPES.SUBCATEGORY:
            const subCatParams = { source: TAG_SOURCE, pos, name: tag.subCategorySlug };
            const { categorySlug, subCategorySlug } = tag;
            return getSubCategoryUrl({ categorySlug, subCategorySlug, params: subCatParams });
        case POPULAR_SEARCH_TYPES.STORE:
            const storeParams = { source: TAG_SOURCE, pos, name: tag.storeSlug };
            return getStoreUrl(tag.storeSlug, storeParams);
        case POPULAR_SEARCH_TYPES.SEARCH:
            const searchParams = { source: TAG_SOURCE, pos, query: tag.term };
            return getSearchUrl(searchParams);
        default:
            return '';
    }
};

/**
 * This method will return popular search values
 * @return Array.<String>> filtered popular search
 * **/
export const getPopularSearch = () => popularSearches;
